<template>
  <div>
    <v-card class="mx-auto" max-width="1000" elevation="0" style="margin:10px;">
      <v-row>
        <v-col md="3"></v-col>
        <v-col md="6">
          <h3 style="text-align:center;color:black;padding-top:20px;">
            <b>Password reset</b>
          </h3>

          <h5>Enter the token received on your email id and new password.</h5>
          <br />
          <br />
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="otp"
              prepend-icon="mdi-account"
              label="OTP"
              type="text"
              required
            />
            <v-text-field
              v-model="password"
              prepend-icon="mdi-account"
              label=" New Password"
              type="password"
              required
              :rules="pwdRules"
            />
            <v-text-field
              id="passwordcnf"
              v-model="passwordcnf"
              prepend-icon="mdi-lock"
              label="Confirm Password"
              type="password"
              required
              :rules="pwdConfirm"
            />
            <p style="color:red">{{msg4}}</p>

            <!-- <v-text-field
           
            prepend-icon="mdi-account"
            label=" Confirm Password"
            type="text"
            required
            />-->

            <v-card-actions>
              <v-spacer />
              <v-flex xs12 md12 pt-2 text-center>
                <v-btn
                  rounded
                  :disabled="false"
                  width="500px"
                  class="text-capitalize hh"
                  dark
                  :ripple="false"
                  @click="logininit"
                >CHANGE PASSWORD</v-btn>
              </v-flex>
              <!-- <v-btn color="#0e4e35" text @click="logininit">SUBMIT</v-btn> -->
            </v-card-actions>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
    <br />
    <br />
    <br />
  </div>
</template>
<script>
import store from "../../store";
import axios from "axios";
import { request } from "http";
export default {
  data() {
    return {
      pwdRules: [v => !!v || "Password required"],
      pwdConfirm: [
        v => !!v || "Confirm password",
        v => v === this.password || "Passwords do not match"
      ],
      passwordcnf: "",
      msg4: "",
      otp: "",
      password: "",
      msg: null,
      // isLoggedIn:false,
      logindialog: false
    };
  },

  methods: {
    logininit() {
      axios({
        method: "POST",
        url: "/forgot/password/change",
        data: {
          otp: this.otp,
          password: this.password
        }
      })
        .then(response => {
          if (response.data.status) {
            this.msg = "successfully updated password";
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/AppLogin/");
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });

      // this.isLoggedIn = true;
      //     this.msg = response.data.msg;
      //     this.logindialog = false;
      //     alert('successfully updated password')
      //      this.$router.push({
      //         name: "AppLogin"
      //       });

      //   } else {
      //     alert(response.data.msg);
      //     this.msg = response.data.msg;
      //   }

      // })
      // .catch(err => {
      //   var msg=err.response.data.msg;
      //   alert(msg);

      // });
    }
  }
};
</script>
<style scoped>
.hh {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
</style>